import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import { ClassValue } from 'classnames/types'
import { FormattedMessage } from 'react-intl'
import styles from '../../../styles'
import { useMediaQuery } from 'react-responsive'
import { Grid } from '@material-ui/core'

const useStyle = makeStyles(
  (theme) => (
    {
      ...styles(theme),
      listStyle: {
        background: 'white',

        '& div p': {
          margin: 0
        }
      },
      listLargeScreenStyle: {
        padding: '35px 35px 35px 50px'
      },
      listSmallScreenStyle: {
        padding: 20
      }
    }
  )
)


const RequestCardEmpty = () => {
  const classes = useStyle()
  const isLargeScreen = useMediaQuery(
    {
      query: '(min-width: 1025px)'
    }
  )

  const listClass: ClassValue = classNames(
    classes.listStyle,
    {
      [classes.listLargeScreenStyle]: isLargeScreen,
      [classes.listSmallScreenStyle]: !isLargeScreen
    }
  )

  const titleClass: ClassValue = classNames(
    classes.colorBlue,
    isLargeScreen ? classes.text0 : classes.text7
  )

  const categoryClass: ClassValue = classNames(
    classes.colorBlue,
    isLargeScreen ? classes.text1_opacity : classes.text2_opacity
  )

  return <Grid container item xs={12} alignItems="center" justify="space-between" className={listClass}>
    <div className="col-xs-3 col-md-1">
      <img src="img/requests/email.svg" alt="Email icon" />
    </div>

    <div className="col-xs-9">
      <p className={titleClass}>
        <FormattedMessage
          id="requests.emptyRequests"
          defaultMessage="Aucune demande en cours"
          description="Request empty"
        />
      </p>

      <p className={categoryClass}>
        <FormattedMessage
          id="requests.emptyRequestsSubText"
          defaultMessage="Toutes vos demandes ont été traitées"
          description="Request empty subtext"
        />
      </p>
    </div>
    <div className="col-xs-2" />
  </Grid>
}

export default RequestCardEmpty
